export const menuOverview = [
  { subscriptionId: 'MOCK_BROADBAND', productType: 'Broadband' },
  { subscriptionId: 'MOCK_FIXEDNET', productType: 'Fixednet' },
  { subscriptionId: 'MOCK_MOBILE', productType: 'Mobile' },
  { subscriptionId: 'MOCK_TV', productType: 'Tv' },
] as const;

export const userProfile = {
  userName: 'Mock User',
  mobilePhoneNumber: '12345678',
  emailAddress: 'mock@user.com',
  userHash: 'mock',
  ssoId: '11111111',
};

export const hasServiceProducts = {
  hasWebmail: false,
  hasYouseeMusik: true,
  hasTv: false,
};

export const hasEmailSubscription = {
  hasSubscription: true,
};
